import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TextboxQuestion } from '../../../classes/question-textbox';

@Component({
  selector: 'bepatient-input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss'],
  standalone: false
})
export class InputTextComponent {
  @Input() question: TextboxQuestion;
  @Input() parent: UntypedFormGroup;
}
